export const ClippingService = {
  clippingDataPrepFromResponse (response) {
    return {
      ...response,
      published_at: response.published_at * 1000,
      thumbnail: response.thumbnail
    }
  }
}
